
import {VideotronSequenceur} from './app/VideotronSequenceur.js'
window.VideotronSequenceur = VideotronSequenceur;
